module.exports = __webpack_public_path__ + "static/media/illustration-001.aa43f5e5.png";